// html-node.component.ts
import { AfterContentInit, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HtmlNode } from './html-parser.service';

@Component({
  selector: 'app-html-node',
  templateUrl: './html-node.component.html',
  styleUrls: ['./html-node.component.scss']
})
export class HtmlNodeComponent implements OnChanges {
  contextobj:any= undefined;
  constructor(private cd:ChangeDetectorRef){

  }
  @Input() nodes!: any; 
  @Input() context!: any;  
  @Input() lines!: any;  

  ngOnChanges(changes:SimpleChanges){
if(changes.lines){
  const ele:any = document.getElementsByClassName('typewriter')?.[0];
  if(changes.lines.currentValue){
    ele ?.style.setProperty(`--lines`, changes.lines.currentValue);
  }
}
  }
  attributeEntries(node) {
    return Object.entries(node.attributes || {}).map(([key, value]) => ({ key, value }));
  }
  generateElementHtml(node: any): any {

    const attr_obj = Object.entries(node.attributes);

    const attr =attr_obj.map(([key, value]) => {
      // Perform operations on each key-value pair
      return `${key}=' ${value} '`;
    });
      const classAttr = node.attributes ? ` ${attr}` : '';
      const inner = (node.children || []).map(child =>
        child.tag === 'text'
          ? child.text
          : this.generateElementHtml(child)
      ).join('');
      return `<${node.tag}${classAttr}>${inner}</${node.tag}>`;
    
  }

  trackById(index: number, item: any): number {
    return item.id; // Assuming each item has a unique 'id'
  }

ngAfterContentInit(){
}


  getContext(node){
// console.log(node,this.context);
const doc_ref_obj = node.children.find(x => x.tag == 'text')
const doc_ref = doc_ref_obj?.text.split('.');
if(doc_ref.length > 0){
  const contextId = doc_ref?.[0];
  const partId = doc_ref?.[1];

const contextobj = this.context.find(c => c?.additionalProperties?.contextId == contextId);
const partobj = contextobj?.additionalProperties.parts.find(p => p?.partId == partId);
  return  {...contextobj,activehover:doc_ref_obj?.text,part:partobj};

}
  }
}
